import { render, staticRenderFns } from "./SystemInfoInsiderServer.vue?vue&type=template&id=4d6985dc&"
import script from "./SystemInfoInsiderServer.vue?vue&type=script&lang=js&"
export * from "./SystemInfoInsiderServer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports